/* Luxury Cosmetic – favoris (stockés dans le navigateur), ajout direct au panier depuis les cartes,
   et tiroir « Choisir ma taille » sur mobile */
(function () {
  var KEY = 'lc-favoris';
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} document.dispatchEvent(new CustomEvent('lc:favoris', { detail: list })); }
  window.LCFavoris = {
    list: read,
    has: function (h) { return read().indexOf(h) > -1; },
    toggle: function (h) { var l = read(), i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.unshift(h); write(l); return i < 0; },
    remove: function (h) { var l = read().filter(function (x) { return x !== h; }); write(l); }
  };
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('.lcf-count').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  document.addEventListener('lc:favoris', function () {
    paintCount();
    document.querySelectorAll('lc-fav-button').forEach(function (el) { el.sync && el.sync(); });
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) document.dispatchEvent(new CustomEvent('lc:favoris')); });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Ajout au panier commun (cartes + tiroir) */
  function postAdd(id, qty, activeEl) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: Number(id), quantity: qty || 1 };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      cart.setActiveElement && activeEl && cart.setActiveElement(activeEl);
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) {
        if (cart && cart.renderContents) { cart.classList && cart.classList.contains('is-empty') && cart.classList.remove('is-empty'); cart.renderContents(j); }
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lc-card-actions', productVariantId: body.id, cartData: j });
        return j;
      });
  }

  /* Tiroir « Choisir ma taille » */
  var Sheet = {
    el: null, data: null, vid: null, qty: 1, opener: null,
    build: function () {
      if (this.el) return;
      var d = document.createElement('div');
      d.className = 'lcsh'; d.hidden = true;
      d.innerHTML = '<div class="lcsh-bg" data-close></div><div class="lcsh-p" role="dialog" aria-modal="true" aria-labelledby="lcsh-t">' +
        '<span class="lcsh-grip" aria-hidden="true"></span>' +
        '<button type="button" class="lcsh-x" data-close aria-label="Fermer"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<div class="lcsh-top"><img class="lcsh-img" alt=""><div><p class="lcsh-k">Choisir ma taille</p><h3 id="lcsh-t" class="lcsh-t"></h3><p class="lcsh-pr"></p><a class="lcsh-a" href="#">Voir la fiche du parfum →</a></div></div>' +
        '<div class="lcsh-sz" role="radiogroup" aria-label="Taille"></div>' +
        '<div class="lcsh-ft"><div class="lcsh-q" aria-label="Quantité"><button type="button" data-q="-1" aria-label="Moins">−</button><span>1</span><button type="button" data-q="1" aria-label="Plus">+</button></div>' +
        '<button type="button" class="lcsh-add"><span>Ajouter au panier</span></button></div></div>';
      document.body.appendChild(d);
      this.el = d;
      d.addEventListener('click', (e) => {
        if (e.target.closest('[data-close]')) return this.close();
        var q = e.target.closest('[data-q]');
        if (q) { this.qty = Math.max(1, Math.min(20, this.qty + Number(q.dataset.q))); d.querySelector('.lcsh-q span').textContent = this.qty; return; }
        var s = e.target.closest('.lcsh-s');
        if (s && !s.disabled) return this.pick(Number(s.dataset.id));
        if (e.target.closest('.lcsh-add')) return this.add();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.el.hidden) this.close(); });
    },
    open: function (data, opener) {
      this.build();
      this.data = data; this.opener = opener; this.qty = 1;
      var d = this.el;
      d.querySelector('.lcsh-img').src = data.img || '';
      d.querySelector('.lcsh-img').style.visibility = data.img ? '' : 'hidden';
      d.querySelector('.lcsh-t').textContent = data.title;
      d.querySelector('.lcsh-a').href = data.url;
      d.querySelector('.lcsh-q span').textContent = '1';
      d.querySelector('.lcsh-sz').innerHTML = data.variants.map(function (v) {
        return '<button type="button" class="lcsh-s" role="radio" data-id="' + v.id + '"' + (v.a ? '' : ' disabled') + '><b>' + esc(v.t) + '</b><span>' + (v.a ? (v.c ? '<s>' + esc(v.c) + '</s> ' : '') + esc(v.p) : 'Épuisé') + '</span></button>';
      }).join('');
      var first = data.variants.filter(function (v) { return v.id === data.v0 && v.a; })[0] || data.variants.filter(function (v) { return v.a; })[0];
      this.pick(first ? first.id : null);
      d.hidden = false;
      document.documentElement.classList.add('lcsh-lock');
      requestAnimationFrame(function () { d.classList.add('on'); });
      setTimeout(function () { var b = d.querySelector('.lcsh-s[aria-checked="true"]') || d.querySelector('.lcsh-x'); b && b.focus({ preventScroll: true }); }, 60);
    },
    pick: function (id) {
      this.vid = id;
      var v = (this.data.variants.filter(function (x) { return x.id === id; })[0]) || null;
      this.el.querySelectorAll('.lcsh-s').forEach(function (b) { b.setAttribute('aria-checked', Number(b.dataset.id) === id); });
      this.el.querySelector('.lcsh-pr').innerHTML = v ? (v.c ? '<s>' + esc(v.c) + '</s> ' : '') + esc(v.p) + ' <small>· ' + esc(v.t) + '</small>' : '';
      var add = this.el.querySelector('.lcsh-add');
      add.disabled = !v; add.querySelector('span').textContent = v ? 'Ajouter au panier' : 'Épuisé';
    },
    add: function () {
      var add = this.el.querySelector('.lcsh-add'), lab = add.querySelector('span');
      if (add.disabled || !this.vid) return;
      add.disabled = true; lab.textContent = 'Ajout…';
      postAdd(this.vid, this.qty, this.opener).then(() => {
        lab.textContent = 'Ajouté ✓'; add.classList.add('is-done');
        setTimeout(() => { this.close(); }, 450);
      }).catch(function (e) {
        lab.textContent = (e && e.description) ? e.description : 'Réessayer';
      }).finally(function () {
        setTimeout(function () { add.disabled = false; add.classList.remove('is-done'); lab.textContent = 'Ajouter au panier'; }, 1600);
      });
    },
    close: function () {
      var d = this.el; if (!d || d.hidden) return;
      d.classList.remove('on');
      document.documentElement.classList.remove('lcsh-lock');
      setTimeout(function () { d.hidden = true; }, 280);
      if (this.opener) try { this.opener.focus({ preventScroll: true }); } catch (e) {}
    }
  };
  window.LCSizeSheet = Sheet;

  /* Cartes « Aussi faits pour vous » (guide Sillage) : même bouton rond + tiroir sur mobile */
  (function () {
    if (document.getElementById('lcq-lpf-css')) return;
    var st = document.createElement('style'); st.id = 'lcq-lpf-css';
    st.textContent = '@media(max-width:749px){.product-card-wrapper.lcq-has-fab .card__inner{transform:none!important}#lpf .lpf-p.lcq-has-fab .lcq{display:none}#lpf .lpf-p .ph{position:relative}' +
      '#lpf .lpf-p .lcq-fab{display:flex;position:absolute;right:8px;bottom:8px;z-index:5;width:44px;height:44px;border-radius:50%;border:0;padding:0;align-items:center;justify-content:center;background:#1c1b19;color:#e2cc9f;box-shadow:0 8px 20px -8px rgba(28,27,25,.6);cursor:pointer}' +
      '#lpf .lpf-p .lcq-fab svg{width:21px;height:21px;fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}' +
      '#lpf .lpf-p .lcq-fab:active{transform:scale(.92)}#lpf .lpf-p .lcq-fab.is-busy{animation:lcq-pulse .9s ease-in-out infinite}#lpf .lpf-p .lcq-fab.is-done{background:#8a6a35;color:#fff}}';
    (document.head || document.documentElement).appendChild(st);
  })();

  if (!customElements.get('lc-fav-button')) {
    customElements.define('lc-fav-button', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('button');
        this.sync();
        this.btn.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          var on = window.LCFavoris.toggle(this.dataset.handle);
          this.btn.classList.remove('pop'); void this.btn.offsetWidth; this.btn.classList.add('pop');
          this.btn.title = on ? 'Retirer des favoris' : 'Ajouter aux favoris';
        });
      }
      sync() { var on = window.LCFavoris.has(this.dataset.handle); this.btn.setAttribute('aria-pressed', on); }
    });
  }

  if (!customElements.get('lc-card-actions')) {
    customElements.define('lc-card-actions', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return; this._ready = true;
        this.card = this.closest('.card-wrapper') || this.parentElement;
        this.add = this.querySelector('.lcq-add');
        this.label = this.add.querySelector('span');
        try { this.data = JSON.parse((this.querySelector('.lcq-data') || {}).textContent || 'null'); } catch (e) { this.data = null; }
        if (!this.data) this.data = this.fromDom();
        this.fab = this.querySelector('.lcq-fab');
        if (!this.fab && this.data && this.card && this.card.querySelector('.ph')) {
          this.fab = document.createElement('button');
          this.fab.type = 'button'; this.fab.className = 'lcq-fab';
          this.fab.setAttribute('aria-label', (this.data.multi ? 'Choisir la taille et ajouter ' : 'Ajouter ') + this.data.title + ' au panier');
          this.fab.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 8h14l-1.2 11.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8zM9 8V6.5a3 3 0 0 1 6 0V8"/><path class="pl" d="M12 11.5v5M9.5 14h5"/></svg>';
          this.appendChild(this.fab);
        }
        if (this.fab) {
          var media = this.card && (this.card.querySelector('.card__inner') || this.card.querySelector('.ph'));
          if (media) { media.appendChild(this.fab); this.card.classList.add('lcq-has-fab'); }
          this.fab.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.quick(); });
        }
        this.querySelectorAll('.lcq-s').forEach((b) => b.addEventListener('click', () => this.pick(b)));
        var sel = this.querySelector('.lcq-select');
        if (sel) sel.addEventListener('change', () => this.pick(sel.options[sel.selectedIndex]));
        this.add.addEventListener('click', () => this.addToCart());
      }
      fromDom() {
        var opts = [].slice.call(this.querySelectorAll('.lcq-s, .lcq-select option'));
        var c = this.card; if (!c) return null;
        var a = c.querySelector('a[href*="/products/"]'), img = c.querySelector('img');
        var name = c.querySelector('.n, .card__heading');
        var v0 = Number(this.add.value);
        var variants = opts.length ? opts.map(function (b) { return { id: Number(b.value), t: b.dataset.title || b.textContent.trim(), p: b.dataset.price || '', c: b.dataset.compare || '', a: !b.hasAttribute('data-soldout') }; })
          : [{ id: v0, t: '', p: '', c: '', a: !this.add.disabled }];
        return { title: name ? name.textContent.trim() : '', url: a ? a.getAttribute('href') : '#', img: img ? (img.currentSrc || img.src) : '', multi: opts.length > 1, v0: v0, variants: variants };
      }
      quick() {
        if (!this.data) return this.addToCart();
        if (this.data.multi) return Sheet.open(this.data, this.fab);
        var f = this.fab; if (f.disabled) return;
        f.disabled = true; f.classList.add('is-busy');
        postAdd(this.data.v0, 1, f).then(function () { f.classList.add('is-done'); })
          .catch(function () { f.classList.add('is-err'); })
          .finally(function () { setTimeout(function () { f.disabled = false; f.classList.remove('is-busy', 'is-done', 'is-err'); }, 1600); });
      }
      pick(el) {
        this.querySelectorAll('.lcq-s').forEach((b) => b.setAttribute('aria-checked', b === el));
        this.add.value = el.value;
        var sold = el.hasAttribute('data-soldout');
        this.add.disabled = sold;
        this.label.textContent = sold ? 'Épuisé' : 'Ajouter au panier';
        var vol = ' · ' + el.dataset.title;
        var priceBox = this.card.querySelector('.price');
        if (priceBox) {
          var html = el.dataset.price + '<span class="lc-vol" style="font-weight:400;opacity:.65;font-size:.9em">' + esc(vol) + '</span>';
          priceBox.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (n) { n.innerHTML = html; });
          var cmp = priceBox.querySelector('.price__sale s.price-item--regular');
          if (cmp && el.dataset.compare) cmp.innerHTML = el.dataset.compare;
          priceBox.classList.toggle('price--on-sale', !!el.dataset.compare);
          priceBox.classList.toggle('price--sold-out', sold);
        }
      }
      addToCart() {
        if (this.add.disabled) return;
        this.add.disabled = true; this.add.setAttribute('aria-busy', 'true'); this.label.textContent = 'Ajout…';
        postAdd(this.add.value, 1, this.add)
          .then(() => { this.label.textContent = 'Ajouté ✓'; this.add.classList.add('is-done'); })
          .catch((e) => { this.label.textContent = (e && (e.description || e.message)) ? 'Indisponible' : 'Réessayer'; })
          .finally(() => {
            setTimeout(() => { this.add.disabled = false; this.add.removeAttribute('aria-busy'); this.add.classList.remove('is-done'); this.label.textContent = 'Ajouter au panier'; }, 2000);
          });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintCount); else paintCount();
})();
